import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    
    // Otherwise, scroll to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: pathname === '/' ? 'auto' : 'smooth' 
    });
  }, [pathname, hash, key]); 

  return null;
};

export default ScrollToTop;